(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
	const announcementHeight = () => {
		// Select all elements
		const announcements = document.querySelectorAll(
			'.shopify-section-group-header-group.section-announcement'
		);

		if (announcements.length === 0) {
			return;
		}

		// Initialize the variable to store the total height
		let announcementHeight = 0;

		// Iterate over each element and add its height to the total
		announcements.forEach((announcement) => {
			const height = announcement.offsetHeight; // Get the height of the element
			announcementHeight += height; // Add it to the total
		});

		document.documentElement.style.setProperty(
			'--announcement-height',
			`${announcementHeight}px`
		);
		return announcementHeight;
	};

	announcementHeight();

	const iconClose = () => {
		const icons = document.querySelectorAll(".icon-close");
		icons.forEach((icon) => {
			icon.addEventListener("click", function () {
				const announcement = icon.closest(".section-announcement");
				if (announcement) {
					announcement.style.display = "none";
				}
				announcementHeight();
			});
		});
	};

	iconClose();

	document.addEventListener('shopify:section:load', function () {
		announcementHeight();
		iconClose();
	});
	window.addEventListener('resize', announcementHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerOverlay = document.querySelector('.header-overlay');
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';
		
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky','always-fixed');
			if (this.headerOverlay && headerOverlayWithBackground) {
				//this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}			
			if (this.headerOverlay && !headerOverlayWithBackground) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		this.headerBounds = this.header.getBoundingClientRect();
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const isBurgerMenuActive = document.querySelector('.burger-drawer.active');
		if (isBurgerMenuActive) return;

		// Homepage: simple 2-state (transparent at top, sticky when scrolled)
		if (document.body.classList.contains('body-template-index')) {
			if (scrollTop > 0) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.remove('shopify-section-header-hidden');
			} else {
				this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			}
			this.currentScrollTop = scrollTop;
			return;
		}

		// Non-homepage: existing hide/reveal behavior
		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);
				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);
				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= 5) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (document.querySelector(".search-modal.active")) return;
		if (document.querySelector(".header__account.active")) return;
		if (document.querySelector(".burger-drawer.active")) return;
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		if (this.headerOverlay && !headerOverlayWithBackground ) {
			this.headerOverlay.classList.add('color-background-1');
		}
	}

	reveal() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-inverse');
		if (this.headerOverlay && headerOverlayWithBackground) {
			//this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}
		if (this.headerOverlay && !headerOverlayWithBackground) {
			this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}

		if (document.querySelector(".shopify-section-header .scroll_color")) {
        const backgroundElements = this.header.querySelectorAll(".header-top-background");

        backgroundElements.forEach((element) => {
            if (!element.dataset.originalClass) {
                element.classList.forEach((className) => {
                    if (className.startsWith("color-background-")) {
                        element.dataset.originalClass = className;
                        element.classList.remove(className);
                    }
                });
            }
            element.classList.add("color-background-1");
        });
    }
	}

	reset() {
		const headerOverlayWithBackground = document.querySelector('[data-overlay-with-background]')?.dataset.overlayWithBackground === 'true';

		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.headerOverlay && headerOverlayWithBackground) {
			//this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}		
		if (this.headerOverlay && !headerOverlayWithBackground) {
			this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}

		if (document.querySelector(".shopify-section-header .scroll_color")) {
			const backgroundElements = this.header.querySelectorAll(".header-top-background");
			backgroundElements.forEach((element) => {
					element.classList.remove("color-background-1");

					if (element.dataset.originalClass) {
							element.classList.add(element.dataset.originalClass);
							delete element.dataset.originalClass;
					}
			});
		}
	}

	//closeMenuDisclosure() {
	//	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	//	this.disclosures.forEach(disclosure => disclosure.close());
	//}

	}

	customElements.define('sticky-header', StickyHeader);	
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
					const initSlider = () => {
						document
							.querySelectorAll(".js-recommendation-swiper")
							.forEach((elem, index) => {
								let slider = new Swiper(elem, {
									slidesPerView: 1,
									spaceBetween: 0,
									speed: 600,
									navigation: {
										nextEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-next"
										),
										prevEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-prev"
										),
									},
								});
							});
					};
					initSlider()
				})
				.catch(e => {
					console.error(e);
				});
				
		}
		
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-also-like"] && !Shopify.designMode) return;
  try {
    
	class PdpAlsoLike extends HTMLElement {
		connectedCallback() {
			const existing = this.querySelectorAll('.swiper-slide[data-pid]');
			const max = parseInt(this.dataset.max) || 10;
			if (existing.length < max) {
				const ids = [...existing].map(s => parseInt(s.dataset.pid));
				this.supplement(max - existing.length, ids);
			}
		}

		async supplement(needed, renderedIds) {
			const productId = this.dataset.productId;
			try {
				const resp = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (needed + renderedIds.length) + '&intent=related');
				if (!resp.ok) return;
				const data = await resp.json();
				const products = data.products.filter(function(p) { return renderedIds.indexOf(p.id) === -1; }).slice(0, needed);

				if (products.length === 0) return;

				const slidesContainer = this.querySelector('.swiper-wrapper');
				if (!slidesContainer) return;

				const fetches = products.map(function(p) {
					return fetch('/products/' + p.handle + '?sections=pdp-rv-card')
						.then(function(r) { return r.ok ? r.json() : null; })
						.catch(function() { return null; });
				});

				const results = await Promise.all(fetches);
				let added = false;

				results.forEach(function(cardData) {
					if (!cardData) return;
					var html = Object.values(cardData)[0];
					if (!html || !html.trim()) return;
					var slide = document.createElement('div');
					slide.className = 'products-slider__slide swiper-slide';
					slide.innerHTML = html;
					slidesContainer.appendChild(slide);
					added = true;
				});

				if (!added) return;

				// Show section if it was hidden (no collection products case)
				this.style.display = '';

				// Update or init Swiper
				var swiperEl = this.querySelector('.swiper');
				if (swiperEl && swiperEl.swiper) {
					swiperEl.swiper.update();
				} else {
					var sectionId = this.dataset.sectionId;
					var perRow = parseInt(this.dataset.perRow) || 5;
					var speed = (parseFloat(this.dataset.speed) || 1.1) * 1000;
					var delay = (parseFloat(this.dataset.delay) || 3) * 1000;
					new Swiper('#' + sectionId + ' .swiper', {
						speed: speed,
						keyboard: true,
						slidesPerView: 2,
						spaceBetween: 16,
						autoplay: { delay: delay, pauseOnMouseEnter: false, disableOnInteraction: false },
						navigation: {
							nextEl: '#' + sectionId + ' .swiper-button-next',
							prevEl: '#' + sectionId + ' .swiper-button-prev',
						},
						pagination: {
							el: '#' + sectionId + ' .products-slider-pagination',
							clickable: true,
						},
						breakpoints: {
							576: { slidesPerView: perRow >= 2 ? 2 : 1 },
							750: { slidesPerView: perRow >= 3 ? 3 : perRow },
							990: { slidesPerView: perRow >= 4 ? 4 : perRow },
							1150: { spaceBetween: 16, slidesPerView: perRow }
						}
					});
				}

				if (window.initCardSliders) window.initCardSliders(this);
				if (window.initPreorderTimers) window.initPreorderTimers();
			} catch(e) {
				console.error('PdpAlsoLike:', e);
			}
		}
	}
	if (!customElements.get('pdp-also-like')) {
		customElements.define('pdp-also-like', PdpAlsoLike);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
	class PdpRecentlyViewed extends HTMLElement {
		constructor() {
			super();
			const oldData = localStorage.getItem('rsrv_recently_viewed');
			if (oldData) { localStorage.setItem('anchor_recently_viewed', oldData); localStorage.removeItem('rsrv_recently_viewed'); }
			const STORAGE_KEY = 'anchor_recently_viewed';
			const MAX_ITEMS = 20;
			const currentHandle = this.dataset.currentHandle;
			const maxShow = parseInt(this.dataset.max) || 10;

			// Save current product to recently viewed
			if (currentHandle) {
				let items = [];
				try { items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) {}
				items = items.filter(h => h !== currentHandle);
				items.unshift(currentHandle);
				if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
				try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e) {}
			}

			// Load recently viewed directly (element starts display:none so IntersectionObserver won't fire)
			this.loadRecentlyViewed(STORAGE_KEY, currentHandle, maxShow);
		}

		async loadRecentlyViewed(storageKey, currentHandle, maxShow) {
			let items = [];
			try { items = JSON.parse(localStorage.getItem(storageKey)) || []; } catch(e) {}
			items = items.filter(h => h !== currentHandle).slice(0, maxShow);

			if (items.length === 0) return;

			const slidesContainer = this.querySelector('.js-rv-slides');
			if (!slidesContainer) return;

			const fetches = items.map(handle =>
				fetch('/products/' + handle + '?sections=pdp-rv-card')
					.then(r => r.ok ? r.json() : null)
					.catch(() => null)
			);

			const results = await Promise.all(fetches);
			let hasCards = false;

			results.forEach(data => {
				if (!data) return;
				const html = Object.values(data)[0];
				if (!html || !html.trim()) return;
				const slide = document.createElement('div');
				slide.className = 'products-slider__slide swiper-slide';
				slide.innerHTML = html;
				slidesContainer.appendChild(slide);
				hasCards = true;
			});

			if (!hasCards) return;

			// Show the section
			this.style.display = '';

			// Init Swiper
			const sectionId = this.dataset.sectionId;
			const perRow = parseInt(this.dataset.perRow) || 5;
			const speed = (parseFloat(this.dataset.speed) || 1.1) * 1000;
			const delay = (parseFloat(this.dataset.delay) || 3) * 1000;
			new Swiper('#' + sectionId + ' .swiper', {
				speed: speed,
				keyboard: true,
				slidesPerView: 2,
				spaceBetween: 16,
				autoplay: { delay: delay, pauseOnMouseEnter: false, disableOnInteraction: false },
				navigation: {
					nextEl: '#' + sectionId + ' .swiper-button-next',
					prevEl: '#' + sectionId + ' .swiper-button-prev',
				},
				pagination: {
					el: '#' + sectionId + ' .products-slider-pagination',
					clickable: true,
				},
				breakpoints: {
					576: { slidesPerView: perRow >= 2 ? 2 : 1 },
					750: { slidesPerView: perRow >= 3 ? 3 : perRow },
					990: { slidesPerView: perRow >= 4 ? 4 : perRow },
					1150: { spaceBetween: 16, slidesPerView: perRow }
				}
			});

			if (window.initCardSliders) window.initCardSliders(this);
			if (window.initPreorderTimers) window.initPreorderTimers();
		}
	}
	if (!customElements.get('pdp-recently-viewed')) {
		customElements.define('pdp-recently-viewed', PdpRecentlyViewed);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
	class PdpSimilarProducts extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('pdp-similar-products');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
						const initSlider = () => {
							const slider = this.querySelector('.products-slider');
							if (!slider) return;
							slider.classList.remove('slider_started');
							const sectionId = slider.dataset.id;
							const perRow = parseInt(slider.dataset.perRow) || 5;
							const speed = (parseFloat(slider.dataset.speed) || 1.1) * 1000;
							const delay = (parseFloat(slider.dataset.delay) || 3) * 1000;
							new Swiper('#' + sectionId + ' .swiper', {
								speed: speed,
								keyboard: true,
								slidesPerView: 2,
								spaceBetween: 16,
								autoplay: { delay: delay, pauseOnMouseEnter: false, disableOnInteraction: false },
								navigation: {
									nextEl: '#' + sectionId + ' .swiper-button-next',
									prevEl: '#' + sectionId + ' .swiper-button-prev',
								},
								pagination: {
									el: '#' + sectionId + ' .products-slider-pagination',
									clickable: true,
								},
								breakpoints: {
									576: { slidesPerView: perRow >= 2 ? 2 : 1 },
									750: { slidesPerView: perRow >= 3 ? 3 : perRow },
									990: { slidesPerView: perRow >= 4 ? 4 : perRow },
									1150: { spaceBetween: 16, slidesPerView: perRow }
								}
							});
						};
						initSlider();
						if (window.initCardSliders) window.initCardSliders(this);
						if (window.initPreorderTimers) window.initPreorderTimers();
					})
					.catch((e) => { console.error(e); });
			};
			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 400px 0px',
			}).observe(this);
		}
	}
	if (!customElements.get('pdp-similar-products')) {
		customElements.define('pdp-similar-products', PdpSimilarProducts);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recommended"] && !Shopify.designMode) return;
  try {
    
	class PdpRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);
				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('pdp-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
						const initSlider = () => {
							const slider = this.querySelector('.products-slider');
							if (!slider) return;
							slider.classList.remove('slider_started');
							const sectionId = slider.dataset.id;
							const perRow = parseInt(slider.dataset.perRow) || 5;
							const speed = (parseFloat(slider.dataset.speed) || 1.1) * 1000;
							const delay = (parseFloat(slider.dataset.delay) || 3) * 1000;
							new Swiper('#' + sectionId + ' .swiper', {
								speed: speed,
								keyboard: true,
								slidesPerView: 2,
								spaceBetween: 16,
								autoplay: { delay: delay, pauseOnMouseEnter: false, disableOnInteraction: false },
								navigation: {
									nextEl: '#' + sectionId + ' .swiper-button-next',
									prevEl: '#' + sectionId + ' .swiper-button-prev',
								},
								pagination: {
									el: '#' + sectionId + ' .products-slider-pagination',
									clickable: true,
								},
								breakpoints: {
									576: { slidesPerView: perRow >= 2 ? 2 : 1 },
									750: { slidesPerView: perRow >= 3 ? 3 : perRow },
									990: { slidesPerView: perRow >= 4 ? 4 : perRow },
									1150: { spaceBetween: 16, slidesPerView: perRow }
								}
							});
						};
						initSlider();
						if (window.initCardSliders) window.initCardSliders(this);
						if (window.initPreorderTimers) window.initPreorderTimers();
					})
					.catch((e) => { console.error(e); });
			};
			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 400px 0px',
			}).observe(this);
		}
	}
	if (!customElements.get('pdp-recommendations')) {
		customElements.define('pdp-recommendations', PdpRecommendations);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						const initProductSlider = () => {
							var swiper = new Swiper('.swiper-container', {
								slidesPerView: 1,

								spaceBetween: 0,
								navigation: {
									nextEl: '.product-button-group .swiper-button-next-1',
									prevEl: '.product-button-group .swiper-button-prev-1',
								},
							});
						};

						initProductSlider();
						buttonHoverEffects();
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
